import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import OnboardingOverlay from '../features/guide/OnboardingOverlay';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';
import { PlatformMessageBanner } from '../features/messages/PlatformMessageBanner';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useKeyboardShortcuts();

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[#0a0a0a]">
      <Header onToggleSidebar={() => setSidebarOpen((v) => !v)} />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <main className="flex-1 overflow-y-auto">
          <PlatformMessageBanner />
          <Outlet />
        </main>
      </div>

      <OnboardingOverlay />
    </div>
  );
}
